import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundScrollToBottom = this.scrollToBottom.bind(this)
    this.boundHighlightMessage = this.highlightMessage.bind(this)
    document.addEventListener('chat:scroll-to-bottom', this.boundScrollToBottom)
    document.addEventListener('chat:highlight-message', this.boundHighlightMessage)
  }

  disconnect() {
    document.removeEventListener('chat:scroll-to-bottom', this.boundScrollToBottom)
    document.removeEventListener('chat:highlight-message', this.boundHighlightMessage)
  }

  scrollToBottom(event) {
    const smooth = event?.detail?.smooth ?? false
    this.element.scrollTo({
      top: this.element.scrollHeight,
      behavior: smooth ? "smooth" : "auto"
    })
  }

  highlightMessage(event) {
    const messageId = event?.detail?.messageId
    if (!messageId) return
    this.highlightMessageById(Number(messageId), 0)
  }

  highlightMessageById(messageId, attempt = 0) {
    const id = Number(messageId)
    if (Number.isNaN(id)) return

    const messageEl = document.getElementById(`chat_message_${id}`)
    if (!messageEl) {
      if (attempt >= 8) return
      setTimeout(() => {
        this.highlightMessageById(id, attempt + 1)
      }, 120)
      return
    }

    const bubbleEl = messageEl.querySelector('[data-chat-message-bubble]')
    if (!bubbleEl) {
      if (attempt >= 8) return
      setTimeout(() => {
        this.highlightMessageById(id, attempt + 1)
      }, 120)
      return
    }

    messageEl.scrollIntoView({ behavior: 'smooth', block: 'center' })

    bubbleEl.classList.add('transition-all', 'duration-700')
    bubbleEl.style.boxShadow = 'inset 0 0 0 999px rgba(251, 191, 36, 0.6)'

    setTimeout(() => {
      bubbleEl.style.boxShadow = ''
    }, 1800)
  }
}
